import React from 'react';

// Reusable page container for consistent width & padding.
// Adds an explicit inline maxWidth to avoid any Tailwind JIT / ordering flash
// where the class might momentarily not apply, causing a width jump.
export default function PageContainer({ children, className = '', style = {} }) {
  return (
    <div
      className={`page-container mx-auto w-full max-w-7xl px-6 py-6 ${className}`.trim()}
      style={{ maxWidth: '80rem', ...style }}
    >
      {children}
    </div>
  );
}
